export enum UBXLayout {
    BL = 0,
    BC = 1,
    BR = 2,
    CL = 3,
    CC = 4,
    CR = 5,
    TL = 6,
    TC = 7,
    TR = 8,
}
